import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterDropdown } from '../molecules/FilterDropdown';
import { MARKET_REGIONS_US } from 'constants/Regions';
const REGIONS = MARKET_REGIONS_US;
/**
 * Shared market region multi-select filter.
 * Uses MARKET_REGIONS_US constant.
 */
export function MarketRegionFilter({ value, onChange, }) {
    const { t } = useTranslation();
    const allValues = REGIONS.map((r) => r.value);
    const options = REGIONS.map((type) => ({
        value: type.value,
        label: t(type.localizationSlug),
    }));
    return (React.createElement(FilterDropdown, { title: t('REGIONS'), options: options, selected: value, onCheckedChange: (item, checked) => {
            onChange(checked ? [...value, item] : value.filter((v) => v !== item));
        }, onSelectAll: () => onChange([...allValues]), onClear: () => onChange([]) }));
}
